import React, { useState } from 'react';
import { MOOD_LABELS, MOOD_CONTEXTS } from '../../utils/constants';
import { useTheme } from '../../hooks/useTheme';

const MoodHistory = ({ moodData }) => {
  const [showAll, setShowAll] = useState(false);
  const { theme } = useTheme();

  const displayData = showAll ? moodData : moodData.slice(-3);

  return (
    <div className={`p-6 rounded-xl ${theme === 'dark' ? 'bg-gray-800' : 'bg-white'} shadow-lg`}>
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-semibold">Recent Entries</h3>
        {moodData.length > 3 && (
          <button
            onClick={() => setShowAll(!showAll)}
            className="text-sm text-blue-600 hover:underline"
          >
            {showAll ? 'Hide' : 'Show All'}
          </button>
        )}
      </div>
      
      <div className="space-y-3">
        {displayData.length === 0 ? (
          <p className="text-gray-500 text-center py-4">No mood entries yet</p>
        ) : (
          displayData.reverse().map(entry => (
            <div 
              key={entry.id} 
              className={`p-4 rounded-lg ${theme === 'dark' ? 'bg-gray-700' : 'bg-gray-50'}`}
            >
              <div className="flex items-start justify-between">
                <div>
                  <div className="flex items-center space-x-3 mb-2">
                    <span className="text-2xl">
                      {MOOD_LABELS.find(m => m.value === entry.mood)?.emoji}
                    </span>
                    <span className="font-medium">
                      {MOOD_LABELS.find(m => m.value === entry.mood)?.label}
                    </span>
                    <span className="text-sm text-gray-500">
                      {new Date(entry.date).toLocaleDateString()}
                    </span>
                  </div>
                  {entry.contexts.length > 0 && (
                    <div className="flex flex-wrap gap-2 mb-2">
                      {entry.contexts.map(contextId => {
                        const context = MOOD_CONTEXTS.find(c => c.id === contextId);
                        return context ? (
                          <span 
                            key={contextId}
                            className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded"
                          >
                            {context.icon} {context.label}
                          </span>
                        ) : null;
                      })}
                    </div>
                  )}
                  {entry.note && (
                    <p className="text-sm text-gray-600 italic">"{entry.note}"</p>
                  )}
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default MoodHistory;